import { AMANDA_SERVICE_ACCOUNT, AMANDA_URL } from "application/constants/app-constants";
import { split, filter, map, clone, remove, toLower, length } from "ramda";
import Axios from "axios";
import showToast from "./showToast";

const uploadImage = (i, files, setProgress, progressIndex, setShowSpinner) =>
  new Promise((resolve, reject) => {
    if (!files[i]) {
      reject(null);
      return;
    }
    const newFile = new File(
      [files[i]],
      toLower(`${Date.now()}.${split(".", files[i].name)[split(".", files[i].name).length - 1]}`),
      {
        type: files[i].type,
      }
    );

    const signedBody = {
      optimize: false,
      metadata: {
        brand: "Zara",
      },
      application: "ZaraRepairDonate",
      contentType: newFile.type,
      contentLength: newFile.size,
      originalAssetName: newFile.name,
      serviceAccount: AMANDA_SERVICE_ACCOUNT,
      visibility: "PUBLIC",
      tenant: "ZARA",
    };

    setShowSpinner[progressIndex](true);

    Axios.post(`${AMANDA_URL}/v2/signedUrl`, signedBody, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((v) => {
        const putHeaders = {
          "x-goog-content-length-range": `${newFile.size},${newFile.size}`,
          "x-goog-meta-sa": AMANDA_SERVICE_ACCOUNT,
          "x-goog-meta-assetid": v.data.assetId,
          "x-goog-meta-originalassetname": newFile.name,
          "x-goog-meta-tenant": "ZARA",
          "x-goog-meta-visibility": "PUBLIC",
          "x-goog-meta-application": "ZaraRepairDonate",
          "Content-Type": newFile.type,
          "x-goog-meta-version": 2,
        };

        Axios({
          method: "put",
          url: v.data.url,
          data: newFile,
          headers: putHeaders,
          onUploadProgress: (progressEvent) => {
            const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setProgress[progressIndex](percentage);
            setShowSpinner[progressIndex](percentage === 100 ? false : true);
          },
        })
          .then(() => {
            resolve({ file: newFile, assetId: `${v.data.assetId},${newFile.name}` });
          })
          .catch(() => {
            showToast();
            reject(null);
          });
      })
      .catch(() => {
        showToast();
        reject(null);
      });
  });

export const handleFiles = (files, imagesUrl, setImagesUrl, imgArr, setImgArr, setProgress, setShowSpinner) => {
  Promise.allSettled([
    uploadImage(0, files, setProgress, length(imagesUrl), setShowSpinner),
    uploadImage(1, files, setProgress, length(imagesUrl) + 1, setShowSpinner),
    uploadImage(2, files, setProgress, length(imagesUrl) + 2, setShowSpinner),
  ]).then((allResponses) => {
    const responsesFulfilled = filter((r) => r.status === "fulfilled", allResponses);
    const newImages = [...imagesUrl, ...map((r) => r.value.file, responsesFulfilled)];
    const newIdList = [...imgArr, ...map((r) => r.value.assetId, responsesFulfilled)];

    setImagesUrl(newImages);
    setImgArr(newIdList);
  });
};

export const handleUpdateFile = (file, imagesUrl, setImagesUrl, imgArr, setImgArr, index) => {
  uploadImage(0, [file])
    .then((v) => {
      const newImages = clone(imagesUrl);
      const newIdList = clone(imgArr);

      newImages[index] = file;
      newIdList[index] = `${v.assetId}, ${file.name}`;

      setImagesUrl(newImages);
      setImgArr(newIdList);
    })
    .catch((e) => {
      const newImages = remove(index, 1, imagesUrl);
      const newIdList = remove(index, 1, imgArr);

      setImagesUrl(newImages);
      setImgArr(newIdList);
    });
};
